import { Attrs, MinzeAttrs, MinzeElement, EventListeners, Reactive } from 'minze'
import { Font } from '../../../constants'
import { Callback } from '../../../modules/callback'

export interface LvcToggle {
  onClick: string
}

export class LvcToggle extends MinzeElement {
  reactive: Reactive = [['toggled', false, true]]
  attrs: MinzeAttrs = ['on-click', 'initial-toggled', 'read-only', 'id']

  static get observedAttributes(): string[] {
    return ['initial-toggled']
  }

  onAttributeChange(name: string, oldValue: string, value: string): void {
    if (name === 'initial-toggled') {
      this.toggled = value === 'true'
    }
    this.rerender()
  }

  onButtonClick(): void {
    if (this.readOnly) return
    this.toggled = !this.toggled
    this.rerender()
    Callback.call(this.onClick, this.toggled, this.id)
  }

  html = () => `
    <button class="toggle" name="toggle" id="${this.id}" data-toggled="${this.toggled}">
      <div class="toggle-icon"></div>
    </button>
  `

  css = () => `
    .toggle {
      display: flex;
      border: none;
      position: relative;
      flex-direction: row;
      align-items: center;
      height: 30px;
      width: 58px;
      border-radius: 60px;
      background: ${this.toggled ? 'rgba(30, 0, 125)' : 'rgba(30,0,125, 0.3)'};
      cursor: pointer;
      box-sizing: border-box;
    }
    .toggle-icon {
      background: white;
      width: 24px;
      height: 24px;
      border-radius: 100%;
      position: absolute;
      left: ${this.toggled ? 'calc(58px - 27px)' : '3px'};
      transition: all 0.3s;
    }
  `

  eventListeners: EventListeners = [['[name="toggle"]', 'click', this.onButtonClick.bind(this)]]
}
